import { actions, getLanguagesLookupsAsync } from './slices';

export const LanguagesActions = {
  ...actions,
  getLanguagesLookupsAsync,
};

export * from './thunkHandlers';
